import {
  microFrontendsMetadataHome,
  microFrontendsMetadataLoan,
  microFrontendsMetadataSteps,
  microFrontendsMetadataFTD,
  microFrontendsMetadataEnrollment,
  microFrontendsMetadataBiometrics,
  microFrontendsMetadataOcupacion,
} from './routes.config';

export const microFrontendsMetadata = [
  microFrontendsMetadataHome,
  microFrontendsMetadataSteps,
  microFrontendsMetadataLoan,
  microFrontendsMetadataFTD,
  microFrontendsMetadataEnrollment,
  microFrontendsMetadataBiometrics,
  microFrontendsMetadataOcupacion,
];
